// 非掲載案件に直接ランディングした場合に表示されるレコメンド

export function recommends() {
  const items = document.querySelectorAll<HTMLElement>('.js-recommend-items')
  if (items.length === 0) return

  for (let i = 0; i < items.length; i++) {
    const showRecommendItem = items[i].querySelector<HTMLElement>('.js-show-recommend-item')
    if (showRecommendItem === null) return

    const recommendItem = items[i].querySelectorAll<HTMLElement>('.js-recommend-item')
    if (recommendItem.length <= 4) {
      showRecommendItem.remove()
      return
    }

    // 「つづきを見る」ボタン押下時の処理
    showRecommendItem.addEventListener('click', () => {
      recommendItem.forEach((el) => {
        const styles = getComputedStyle(el)
        if (styles.display === 'none') {
          el.style.display = 'block'
        }
      })
      showRecommendItem.remove()
    })
  }
}
